function cov_26aocuxcxz() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/platform/PrivacyPolicy/index.ts";
  var hash = "28d8a43569249ffebc3eb8762f1301e3778ad828";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/platform/PrivacyPolicy/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "28d8a43569249ffebc3eb8762f1301e3778ad828"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_26aocuxcxz = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_26aocuxcxz();
export { PrivacyPolicy } from './PrivacyPolicy';